import React from 'react';
import { ThemeProvider } from 'styled-components';
import Context from './selectable-list-context';
import { ID, State, SelectableListTheme, Props } from './types';

const defaultTheme: SelectableListTheme = {
  indent: 1,
  nestedListProperty: 'list',
};

export class SelectableListController extends React.Component<Props, State> {
  static defaultProps = {
    theme: defaultTheme,
  };

  state: State = {
    selected: [],
  };

  handleSelect = (id: ID) => () => {
    const { onChange } = this.props;

    this.setState(({ selected }) => {
      const updated = this.isSelected(id)
        ? selected.filter(s => s !== id)
        : selected.concat(id);

      onChange && typeof onChange === 'function' && onChange(updated);

      return {
        selected: updated,
      };
    });
  };

  isSelected = (id: ID) => this.state.selected.includes(id);

  componentDidMount() {
    const { defaultSelection, onChange } = this.props;
    if (defaultSelection) {
      this.setState({ selected: defaultSelection });
      onChange && typeof onChange === 'function' && onChange(defaultSelection);
    }
  }

  render() {
    const { filter, list, theme, children } = this.props;
    const { selected } = this.state;
    const provide = {
      selected,
      list,
      filter,
      handleSelect: this.handleSelect,
      isSelected: this.isSelected,
    };

    return (
      <ThemeProvider theme={theme}>
        <Context.Provider value={provide}>{children}</Context.Provider>
      </ThemeProvider>
    );
  }
}

export default SelectableListController;
